import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Loader2, BookOpen } from 'lucide-react';
import { getCatalogueAuthors } from '../services/cms';
import { useTexts } from '../context/TextsContext';

const Portrait = ({ author, size = 48 }) => (
  <div className="rounded-full overflow-hidden bg-primary/10 flex items-center justify-center shrink-0" style={{ width: size, height: size }}>
    {author.portrait?.url
      ? <img src={author.portrait.url} alt={author.portrait.alt || `Portrait de ${author.name}`} loading="lazy" className="w-full h-full object-cover" data-testid={`author-portrait-${author.slug}`} />
      : <Users className="w-1/2 h-1/2 text-primary" data-testid={`author-fallback-${author.slug}`} />}
  </div>
);

const Authors = () => {
  const { t } = useTexts();
  const [authors, setAuthors] = useState(null);
  useEffect(() => { getCatalogueAuthors().then(setAuthors).catch(() => setAuthors([])); }, []);

  const withComics = (authors || []).filter((a) => a.has_public);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 min-h-[60vh]" data-testid="authors-page">
      <h1 className="font-display font-700 text-4xl text-foreground mb-2 flex items-center gap-3"><Users className="w-8 h-8 text-primary" /> {t('authors_title', 'Auteurs et autrices')}</h1>
      <p className="text-muted-foreground font-600 mb-10 max-w-2xl">{t('authors_intro', 'Les talents qui donnent vie aux webtoons du réel.')}</p>

      {authors === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : withComics.length === 0 ? (
        <p className="text-muted-foreground font-600">{t('authors_empty', 'Aucun auteur avec un webtoon public pour le moment.')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {withComics.map((a, i) => (
            <Link key={a.slug} to={`/auteur/${encodeURIComponent(a.slug)}`} data-testid={`author-card-${a.slug}`} className="card-hover bg-card border border-border rounded-2xl p-5 animate-float-up" style={{ animationDelay: `${i * 50}ms` }}>
              <div className="flex items-center gap-3 mb-2">
                <Portrait author={a} />
                <div className="min-w-0"><h3 className="font-display font-700 truncate">{a.name}</h3>
                <p className="text-xs text-primary font-800 flex items-center gap-1"><BookOpen className="w-3 h-3" /> {a.comics_count} webtoon(s)</p></div>
              </div>
              {a.description && <p className="text-sm text-muted-foreground line-clamp-3">{a.description}</p>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Authors;
